import { Component } from '@angular/core';
import { svgBaseStyles, SvgComponent } from './svg-component';

@Component({
  selector: 'topo-heart-svg',
  standalone: true,
  template: `
    <svg
      [attr.width]="size()"
      [attr.height]="size()"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.5,6A3.49,3.49,0,0,0,8,4.223,3.492,3.492,0,1,0,2.493,8.436L8,14.065l5.338-5.477A3.478,3.478,0,0,0,14.5,6Z"
        fill="none"
        [attr.stroke]="color()" />
    </svg>
  `,
  styles: svgBaseStyles
})
export class HeartSVGComponent extends SvgComponent {}
